import { CategoryUnionType } from '@api';
import { useTranslation } from 'react-i18next';

type FormatCategoriesReturnType = string | undefined;

type UseFormatCategoriesReturnType = {
  formatCategories: (
    categoryIds: CategoryUnionType[]
  ) => FormatCategoriesReturnType;
};

export const useFormatCategories = (): UseFormatCategoriesReturnType => {
  const { t } = useTranslation('common');

  const formatCategories = (
    categoryIds: CategoryUnionType[]
  ): FormatCategoriesReturnType => {
    if (!categoryIds.length) return undefined;

    return categoryIds
      .map((category) => t(`COMPANY_LINKS.CATEGORIES.${category}`))
      .join(', ');
  };

  return { formatCategories };
};
